import React, { PropTypes } from "react";
import Banner from "../components/common/Banner";
import Modal from "react-bootstrap/lib/Modal";

class PolicyPage extends React.Component {
  constructor() {
    super();
    this.state = { showDialog: false, src: null };
  }

  render() {
    return (
      <div>
        <Banner name="Quikr Policies" />

        <div className="container">
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div className="tab-content responsive">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <div className="col-md-6">
                        <div className="col-md-12" style={{ paddingRight: 0 }}>
                          <div className="inner-col-wrap">
                            <table
                              className="table"
                              cellpadding="0"
                              cellspacing="0"
                              border="0"
                            >
                              <thead>
                                <tr>
                                  <th>Quikr Policy Documents</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {/* <img src="/public/images/new.gif" />
                                    &nbsp; */}
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Holiday_List_2025.pdf?v=1",
                                        });
                                      }}
                                    >
                                      Holiday List 2025
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/NPS_presentation.pdf",
                                        });
                                      }}
                                    >
                                      National Pension Scheme
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Leave_Policy_May_2021.pdf",
                                        });
                                      }}
                                    >
                                      Leave Policy
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/codeofconuct.pdf",
                                        });
                                      }}
                                    >
                                      Code of Conduct
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Employee_Referral_Policy_Version5_2023.pdf",
                                        });
                                      }}
                                    >
                                      Employee Referral Policy Version 5
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Travel_policy_2.0.pdf",
                                        });
                                      }}
                                    >
                                      Travel Policy
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/QuikrGeneralITPolicyv2.0.pdf",
                                        });
                                      }}
                                    >
                                      Quikr IT Policy
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Quikr_Policy_on_Prevention_of_Sexual_Harassment_at_Workplace_2022.pdf",
                                        });
                                      }}
                                    >
                                      Policy on Prevention of Sexual Harassment
                                      at WorkPlace
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Quikr_Whistle_Blower_Policy.pdf",
                                        });
                                      }}
                                    >
                                      Whistle Blower Policy
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Separation_from_Services_EXIT_Policy.pdf",
                                        });
                                      }}
                                    >
                                      Separation from Services (EXIT Policy)
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Quikr_Rehire_Policy.pdf",
                                        });
                                      }}
                                    >
                                      Quikr Rehire Policy
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Rights_of_Persons_with_Disabilities_Act.pdf",
                                        });
                                      }}
                                    >
                                      Rights of Persons with Disabilities Act
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-12" style={{ paddingRight: 0 }}>
                          <div className="inner-col-wrap">
                            <table
                              className="table"
                              cellpadding="0"
                              cellspacing="0"
                              border="0"
                            >
                              <thead>
                                <tr>
                                  <th>Cyber Security Policies</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/cyberSecurityPolicy.pdf",
                                        });
                                      }}
                                    >
                                      Cyber Security Policy
                                    </a>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/UserManagementPolicy.pdf",
                                        });
                                      }}
                                    >
                                      User Management Policy
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-12" style={{ paddingRight: 0 }}>
                          <div className="inner-col-wrap">
                            <table
                              className="table"
                              cellpadding="0"
                              cellspacing="0"
                              border="0"
                            >
                              <thead>
                                <tr>
                                  <th>Other Useful Documents</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/QuikrInduction.pdf",
                                        });
                                      }}
                                    >
                                      Quikr Induction Deck
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/CommHand.pdf",
                                        });
                                      }}
                                    >
                                      Communication Handbook
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a
                                      onClick={() => {
                                        this.setState({
                                          showDialog: true,
                                          src: "/public/policy/Employee_Health_Insurance_2024_2025_v4.pdf",
                                        });
                                      }}
                                    >
                                      Employee Medical Insurance
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-6"
                        style={{ paddingRight: 0, marginTop: "0%" }}
                      >
                        <div className="inner-col-wrap">
                          <table
                            className="table"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                          >
                            <thead>
                              <tr>
                                <th>Performance Management Policies</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/PerformanceLinkedVariablePayPolicy.pdf",
                                      });
                                    }}
                                  >
                                    Performance Linked Variable Pay Policy
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/PerformanceManagementPolicy2024.pdf",
                                      });
                                    }}
                                  >
                                    Performance Management Policy{" "}
                                  </a>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/PerformanceImprovementPolicy.pdf",
                                      });
                                    }}
                                  >
                                    Performance Improvement Policy
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <table
                            className="table"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                          >
                            <thead>
                              <tr>
                                <th>Important Contacts</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/contactlist2022/bangalore.pdf",
                                      });
                                    }}
                                  >
                                    Important Contact Details - Bangalore
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/contactlist2022/hyderabad.pdf",
                                      });
                                    }}
                                  >
                                    Important Contact Details - Hyderabad
                                  </a>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/contactlist2022/mumbai.pdf",
                                      });
                                    }}
                                  >
                                    Important Contact Details - Mumbai
                                  </a>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/contactlist2022/chennai.pdf",
                                      });
                                    }}
                                  >
                                    Important Contact Details - Chennai
                                  </a>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/contactlist2022/delhi.pdf",
                                      });
                                    }}
                                  >
                                    Important Contact Details - Delhi
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="inner-col-wrap">
                          <table
                            className="table"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                          >
                            <thead>
                              <tr>
                                <th>Finance</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <a href="/public/policy/Quikr_SOP_Finance_15JAN2020.xlsx">
                                    Vendor Bills /Procurement/Employee
                                    Reimbursement Guideline
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="inner-col-wrap">
                          <table
                            className="table"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                          >
                            <thead>
                              <tr>
                                <th>Sales Policy</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <a
                                    onClick={() => {
                                      this.setState({
                                        showDialog: true,
                                        src: "/public/policy/Conveyance_Policy_V3.pdf",
                                      });
                                    }}
                                  >
                                    Mobile & Conveyance Reimbursement - SM &
                                    Above
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <Modal
                      bsSize="large"
                      show={this.state.showDialog}
                      onHide={() => {
                        this.setState({ showDialog: false });
                      }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Policy&nbsp;</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <iframe
                          style={{ marginTop: "-50px" }}
                          src={this.state.src}
                          width="850"
                          height="500"
                        ></iframe>
                        {this.state.src ==
                        "/public/policy/Travel_policy_2.0.pdf" ? (
                          <a href="/public/policy/travel.xlsx" download={true}>
                            <button className="btn btn-default">
                              Download Form
                            </button>
                          </a>
                        ) : null}
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PolicyPage.propTypes = {};

export default PolicyPage;



/** WEBPACK FOOTER **
 ** ./src/components/PolicyPage.js
 **/